import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

function InvoicePdfModal({ show, onHide, pdfData, invoiceNumber }) {
  if (!pdfData) return null;

  const { dataUrl, docs } = pdfData;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `Invoice_${invoiceNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getDocumentUrl = (doc) => {
    // Use the blobUrl constructed by the backend, similar to BOL documents
    if (doc.blobUrl) {
      return doc.blobUrl;
    }
    // Fallback to API endpoint if no blobUrl is provided
    return `/api/invoices/documents/${doc.fileName}`;
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Invoice {invoiceNumber}
          <Button 
            variant="outline-primary" 
            size="sm" 
            className="ms-3"
            onClick={handleDownload}
          >
            <FontAwesomeIcon icon={faDownload} className="me-1" />
            Download PDF
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '80vh', padding: 0 }}>
        <iframe 
          src={dataUrl}
          width="100%" 
          height="100%"
          style={{ border: 'none' }}
          title={`Invoice ${invoiceNumber}`}
        />
      </Modal.Body>
      {docs && docs.length > 0 && (
        <Modal.Footer className="flex-column align-items-start">
          <h6 className="mb-2">Attachments</h6>
          <div className="w-100">
            {docs.map((doc, index) => (
              <div key={index} className="mb-2">
                <Button
                  variant="link"
                  className="p-0 text-decoration-none"
                  onClick={() => window.open(getDocumentUrl(doc), '_blank')}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                  {doc.descr || doc.Description || doc.fileName}
                </Button>
              </div>
            ))}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default InvoicePdfModal; 